import type { InventoryPurchase } from '../types/inventory';

export interface PurchaseActionVisibility {
  canEdit: boolean;
  canDeleteDraft: boolean;
  canVoid: boolean;
}

/**
 * Fase 17A-4B: qué acciones de escritura debe ofrecer la pantalla de Compras según el estado de la
 * compra. Extraída como función pura (en vez de dejarla solo como condiciones sueltas en el JSX)
 * para poder probar la regla sin necesitar renderizar componentes — este proyecto no tiene
 * infraestructura de pruebas de UI (React Testing Library/jsdom), así que esta es la forma de
 * cubrir la regla real con una prueba automatizada.
 *
 * - DRAFT: se puede editar y eliminar (eliminar no toca inventario porque nunca se confirmó).
 * - CONFIRMED con inventario ya actualizado (`stockPostedAt`): no se puede editar ni eliminar
 *   físicamente — solo anular (con reversa de inventario). Una CONFIRMED que todavía NO actualizó
 *   inventario sigue usando el flujo existente de "Cancelar compra" (sin reversa, porque no hay
 *   nada que revertir), no este.
 * - CANCELLED (incluye la ya anulada): de solo lectura — no editar, no eliminar, no anular de nuevo.
 */
export function getPurchaseActions(purchase: Pick<InventoryPurchase, 'status' | 'stockPostedAt'>): PurchaseActionVisibility {
  return {
    canEdit: purchase.status === 'DRAFT',
    canDeleteDraft: purchase.status === 'DRAFT',
    canVoid: purchase.status === 'CONFIRMED' && Boolean(purchase.stockPostedAt),
  };
}
